import * as XLSX from 'xlsx';

const formatExportDate = (value) => {
  const date = String(value || '').slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(date) ? date.split('-').reverse().join('/') : '';
};

const toExportNumber = (value) => {
  if (value === '' || value === null || value === undefined) return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

const getExportProduct = (row) => {
  const code = String(row.master_provider_code || '');
  const product = code.split('//').slice(1).join('//');
  if (product) return product.replace(/_[^_]+$/, '');

  const type = row.type === 'Transfer' ? 'TF' : row.type === 'Seamless' ? 'SL' : '';
  return [type, row.provider_code || row.provider_name].filter(Boolean).join('//');
};

export const createFinanceReportWorkbook = (report, rows, canViewFinancial) => {
  const month = String(report.report_month || '');
  const hasMonth = /^\d{4}-(0[1-9]|1[0-2])$/.test(month);
  const [year, monthNumber] = month.split('-').map(Number);
  const monthStart = hasMonth ? `${month}-01` : '';
  const monthEnd = hasMonth
    ? `${month}-${new Date(Date.UTC(year, monthNumber, 0)).getUTCDate()}`
    : '';
  const data = [
    ['Code', 'Unique ID', 'Product Category', 'Product', 'Period/Date Range', 'Player W/L', 'Player W/L', 'Client Selling Price %'],
    ['', '', '', '', '', 'SKYONE BO', 'PROVIDER BO', ''],
    ...rows.map(row => {
      const startDate = formatExportDate(row.bo_report_start_date || monthStart);
      const endDate = formatExportDate(row.bo_report_end_date || monthEnd);
      const sellingRate = canViewFinancial ? toExportNumber(row.selling_rate) : null;
      return [
        String(row.shortcode || ''),
        row.master_provider_code || '',
        row.provider_category_name || row.provider_category_code || '',
        getExportProduct(row),
        [startDate, endDate].filter(Boolean).join(' - '),
        toExportNumber(row.bo_winlose_amount),
        toExportNumber(row.provider_winlose_amount),
        sellingRate === null ? null : sellingRate / 100
      ];
    })
  ];
  const worksheet = XLSX.utils.aoa_to_sheet(data);
  worksheet['!cols'] = [10, 42, 22, 30, 28, 20, 20, 26].map(wch => ({ wch }));
  for (let rowNumber = 3; rowNumber < rows.length + 3; rowNumber += 1) {
    ['F', 'G', 'H'].forEach(column => {
      const cell = worksheet[`${column}${rowNumber}`];
      if (cell) cell.z = column === 'H' ? '0.00%' : '#,##0.00';
    });
  }

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Finance Report Detail');
  return workbook;
};

export const exportFinanceReport = (report, rows, canViewFinancial) => {
  const workbook = createFinanceReportWorkbook(report, rows, canViewFinancial);
  const filename = `Finance_Report_${report.title || report._id || 'Detail'}_${report.report_month || ''}`
    .replace(/[<>:"/\\|?*]/g, '_');
  XLSX.writeFile(workbook, `${filename}.xlsx`);
};
